import styled from 'styled-components';

export const PreviewWrapper = styled.div`
  position: fixed;
  pointer-events: none;
  z-index: 999;
  left: 0;
  top: 0;
  transform: translate(-50%, -50%);
`;

export const PreviewItem = styled.div`
  background: #FFFFFF;
  border-radius: 2px;
  border: 1px solid #E5E5E5;
  padding: 10px;
`;
